import { LANGUAGE_SOURCES, type LanguageSource } from "./resolve-widget-language";

// Module scope on purpose: a single i18n instance serves the whole session, so
// the rank has to outlive the remount of any layout that applies a language.
let appliedRank = Number.POSITIVE_INFINITY;

/**
 * Whether `source` may set the language, given what is already in force. A
 * weaker source never overwrites a stronger one, so the order locale arriving
 * after identification cannot undo an explicit `?lang=` or a manual pick.
 * Claiming succeeds for an equal rank, so a source can refresh its own value.
 */
export function claimLanguageRank(source: LanguageSource): boolean {
  const rank = LANGUAGE_SOURCES.indexOf(source);
  if (rank > appliedRank) return false;

  appliedRank = rank;
  return true;
}

export function resetLanguageRank(): void {
  appliedRank = Number.POSITIVE_INFINITY;
}
